<div class="title">{{config.title}}</div>

<input #range (change)="emitChangedValue(range.value)" (ngModelChange)="emitChangingValue($event)"
       [(ngModel)]="config.currentValue" [max]="config.max" [min]="config.min" class="slider" type="range">

<div class="range-titles">
  <label class="range-title">{{config.titleMinRange | translate}}</label>
  <label class="range-title">{{config.titleMaxRange | translate}}</label>
</div>
